import React, { useState, useEffect, useContext } from "react";
import api from "../../api/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
const AddCustomer = ({ closeDial }) => {
  const [country, setCountry] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [newCustomer, setNewCustomer] = useState({
    name: "",
    customerno: "",
    contact_name: "",
    contactno: "",
    email: "",
    designation: "",
    selectedCountry: selectedCountry,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleAddNewCustomer = async () => {
    try {
      const response = await api.post("/api/newcustomers", newCustomer);
      if (response.status === 201) {
        const addedCustomer = response.data;
        setCustomers((prevCustomers) => [...prevCustomers, addedCustomer]);
        setRefreshTrigger(!refreshTrigger);
        setNewCustomer({
          name: "",
          customerno: "",
          contact_name: "",
          contactno: "",
          email: "",
          designation: "",
        });
        setSelectedCountry([]);
        setSelectedCurrency([]);
        closeDialog();
      } else {
        toast.error("Failed to add customer. Please try again.", {
          position: "bottom-center",
          autoClose: 2000,
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        // Handle duplicate customer name error
        toast.error(error.response.data.error, {
          position: "bottom-center",
          autoClose: 2000,
        });
      } else {
        toast.error("Failed to add customer", {
          position: "bottom-center",
          autoClose: 2000,
        });
      }
    }
  };
  useEffect(() => {
    if (selectedCountry.length > 0) {
      const currency = country.find((c) => c.id === Number(selectedCountry));
      setSelectedCurrency(currency.currency);
      setNewCustomer((prev) => ({
        ...prev,
        selectedCountry: selectedCountry,
      }));
    }
  }, [selectedCountry]);
  const closeDialog = () => {
    setNewCustomer({
      name: "",
      customerno: "",
      contact_name: "",
      contactno: "",
      email: "",
      designation: "",
    });
    closeDial(false);
    setSelectedCountry([]);
    setSelectedCurrency([]);
    document.body.classList.remove("no-scroll");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchInitialData = async () => {
    try {
      const counteyRes = await api.get("/api/currency");

      setCountry(counteyRes.data);
    } catch (error) {
      setError(error);
      console.error(
        "Error fetching customer or contact data:",
        error.message || error
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchInitialData();
  }, []);

  return (
    <div className="add-customer-dial">
      <div className="add-customer-content">
        <div className="add-customer-user-header" style={{ marginLeft: "0px" }}>
          <h3
            className="add-project-user-heading"
            style={{ marginLeft: "8px", fontWeight: "550px" }}
          >
            Add New Customer
          </h3>
        </div>
        <div className="customer-form">
          <label className="customer-label">Customer ID</label>
          <input
            type="text"
            name="customerno"
            placeholder="Enter customer ID"
            className="customer-input"
            value={newCustomer.customerno}
            onChange={handleInputChange}
          />

          <label className="customer-label">Customer Name:</label>
          <input
            type="text"
            name="name"
            className="customer-input"
            placeholder="Enter customer name"
            value={newCustomer.name}
            onChange={handleInputChange}
          />

          <label className="customer-label">Contact Name:</label>
          <input
            type="text"
            name="contact_name"
            placeholder="Enter contact name"
            className="customer-input"
            value={newCustomer.contact_name}
            onChange={handleInputChange}
          />

          <label className="customer-label">Designation:</label>
          <input
            type="text"
            name="designation"
            placeholder="Enter designation"
            className="customer-input"
            value={newCustomer.designation}
            onChange={handleInputChange}
          />

          <label className="customer-label">Email:</label>
          <input
            type="text"
            name="email"
            placeholder="Enter email address"
            className="customer-input"
            value={newCustomer.email}
            onChange={handleInputChange}
          />

          <label className="customer-label">Contact No:</label>
          <input
            type="text"
            name="contactno"
            placeholder="Enter contact no"
            className="customer-input"
            value={newCustomer.contactno}
            onChange={handleInputChange}
          />
          <label className="customer-label">Country:</label>
          <select
            className="country-input"
            onChange={(e) => {
              setSelectedCountry(e.target.value);
              setNewCustomer((prev) => ({
                ...prev,
                selectedCountry: e.target.value,
              }));
            }}
            value={selectedCountry || ""}
          >
            <option value="" disabled>
              Select Country
            </option>
            {country.map((c) => (
              <option key={c.id} value={c.id}>
                {c.country}
              </option>
            ))}
          </select>
          <label className="customer-label">Currency:</label>
          <input
            placeholder="Currency"
            className="customer-input"
            value={selectedCurrency || ""}
          />
        </div>
        <div className="customer-btn-container">
          <button
            onClick={handleAddNewCustomer}
            style={{ marginLeft: "24px" }}
            className="add-btn"
          >
            Add
          </button>
          <button onClick={closeDialog} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
export default AddCustomer;
